/* eslint-disable max-len, import/prefer-default-export */
export const shopUrl = 'https://www.redbullshop.com/en-int/wings-for-life-world-run/?utm_campaign=navi&utm_source=live.wingsforlifeworldrun.com&utm_medium=projects&utm_content=en&wt_mc=projects.wingsforlifeworldrun_com.navi'
